module.exports = __webpack_public_path__ + "img/star.4395565a.svg";